export interface CareersPerson {
  // Which slot on the page this item fills. The page matches on it, so an editor
  // can reorder the list without the layouts moving with it.
  key: string
  name: string
  quote: string
  image: string
}

interface CareersPersonSerializerInput {
  key?: string
  name?: string
  quote?: string
  image?: string
}

export function CareersPersonSerializer(
  input: CareersPersonSerializerInput,
): CareersPerson {
  return {
    key: input.key ?? "",
    name: input.name ?? "",
    quote: input.quote ?? "",
    // Empty means no upload in Strapi. Nothing is bundled with the frontend any
    // more, so an item with no upload renders without an illustration.
    image: input.image ?? "",
  }
}
